import { PortModelAlignment } from "@projectstorm/react-diagrams-core";
import { DefaultNodeModel } from "@projectstorm/react-diagrams";
import { toast } from "react-toastify";
import CustomPortModel from "../../ports/CustomPort/CustomPortModel";

export default class LogicNodeModel extends DefaultNodeModel {
  static type = "logic";

  constructor(options) {
    super({
      ...options,
      ...(options.data?.workflow
        ? {
            title: options.data.workflow.Label,
            name: options.data.workflow.UUID || "",
            id: options.data.workflow.UUID,
          }
        : {}),
      type: "logic",
    });

    // setup in and out ports
    if (!options.data.workflow?.IsEntrypoint) {
      this.addPort(
        new CustomPortModel({
          in: true,
          name: "In",
          alignment: PortModelAlignment.LEFT,
        })
      );
    }
  }

  getParentPorts() {
    return Object.values(this.getPort("In")?.links ?? {}).map(
      (link) => link.sourcePort
    );
  }

  getChildrenTypes() {
    return Object.values(this.getPort("Out")?.links ?? {})
      .concat(Object.values(this.getPort("Failed")?.links ?? [])) // get links from both ports
      ?.map((link) => link.targetPort?.parent.type ?? null)
      .filter((item) => item !== null);
  }

  remove(isAllowed) {
    // check if remove is allowed
    if (!isAllowed) {
      toast.error("Please remove the node using delete button");
      return false;
    }

    // check if node is part of a module
    if (
      Object.values(this.getPort("In").getLinks()).find(
        (link) => link.sourcePort.options.isModule
      )
    ) {
      toast.error("You cannot remove a node that is part of a module");
      return false;
    }

    // check if node has a child
    if (
      this.getOutPorts()
        .map((port) => Object.values(port.links))
        .flat().length > 0
    ) {
      toast.error("You cannot remove a node that has a child");
      return false;
    }
   
    // check if node is connected
    if (
      this.getInPorts()
        .map((port) => Object.values(port.links))
        .flat().length > 0
    ) {
      toast.error("You cannot remove a node that is connected. Disconnect node first.");
      return false;
    }

    // check
    if (this.getChildrenTypes().length > 0) {
      toast.error("You cannot remove a node that has a child");
      return false;
    }

    super.remove();
    return true;
  }
}
